define('router',['require','exports','module','backbone','app','modules/profiler','modules/media/pusher'],function(require, exports, module) {"use strict";

	// External dependencies.
	var Backbone = require("backbone");
	var app = require("app");

	var Profiler = require("modules/profiler");
	var Media = require("modules/media/pusher");

	//var Swiper = require("swiper");

	// Defining the application router.
	module.exports = Backbone.Router.extend({

		routes : {
			"" : "index",
			"s/*subroute" : "slide_to"
		},

		index : function(subroute) {
		

			app.ViewType =  this.get_viewtype(subroute) ;
			
		 
			
			//////console.log ( app.swiper  );

		},

		initialize : function() {
			
			app.ViewType={};
			app.current_device={};
			var dv=document.getElementById("device");
			
			app.current_device=dv.innerHTML;
			
				
				document.documentElement.className += " as-type-"+app.current_device;
				
		
				
		},
		
		
		tracker:function(where){
			
		//	console.log('track ', where)
			
			try{
				
				
				s.trackAjaxFotoGallery(where);
				
				
				}catch(e){
					
					
				}
		
			
			
			
		},
		
		
		get_viewtype: function(subroute) {
			
			return Profiler.Tester(subroute);
			
		},

		slide_to : function(subroute) {

			//console.log ('MOVE TO',subroute);
            this.tracker(subroute);
            
          
            
			if(!_.isEmpty(app.ViewType)) {
				
				app.ViewType.moveTo(subroute);
				
			}else{
				////console.log ('MOVE TO',subroute);
				
				app.ViewType = this.get_viewtype(subroute) ;
				
				
				
			}

			/*
			app.swiper.swipeTo(_.findWhere(app.swiper.slides, {
			id : subroute
			}).index());*/

		}
	});
});

